/**
* Creates a new Time Zone Control object which manages the UI representation
* of available time zones and can be interrogated to determine which time
* zone the user has selected
*
* @method TimeZoneControl
* @param {Array} locs	Collection of LocationModels
* @return {Onject}
*/
var TimeZoneControl = function ( locs ) {
	var self = this;

	// Monitors which TZ is selected in the UI
	self.selectedTZ		= ko.observable( null );

	// Exposes the TZs available to the UI
	self.tzs			= ko.observableArray( [] );

	// Best guess at the user's timezone
	self.userTZ			= moment.tz.guess();


	/**
	* Determines if an array has an element with the specified property
	* with a corresponding value
	*
	* @method arrayHasProperty
	* @param {Array} arr
	* @param {String} prop
	* @param {Mixed} val
	* @return {Boolean}
	*/
	self.arrayHas = function ( arr, prop, val ) {
		var found = false;

		arr.forEach( function ( el ) {
			if ( el[ prop ] == val ) {
				found = el;
			}
		});

		return found;
	};


	/**
	* Iterates over locations, looking for Time Zones
	*
	* @method parseLocations
	* @param {Array} locs	Collection of LocationModels
	* @return none
	*/
	self.parseLocations = function ( locs ) {
		var d = new moment(),
			tmp = [ self.userTZ ];

		// Make sure the timezones and selected time zone are reset
		self.reset();

		// Walk over each passed LocationModel and strip the timezone string
		// to a new array
		locs.forEach( function ( loc ) {
			tmp.push( loc.timeZone );
		});

		// Make sure there are no duplicate strings in the collection
		locs = locs.unique();

		// Send the strings off to create a structured array
		tmp = self.processTimeZones( tmp.unique() );

		// Assign the selected tz to the users current tz
		// This case covers single or multiple tz availability
		tmp.forEach( function ( z ) {
			if ( z.olson.contains( self.userTZ ) ) {
				self.selectedTZ( z );
			}
		});

		// Finally assign the collection of tz objects to the observable
		self.tzs( tmp );
	};


	/**
	* Turns the passes array of Olson time zone strings into an
	* array of structured objects
	*
	* @method processTimeZones
	* @param (Array) locs
	* @return {Array}
	*/
	self.processTimeZones = function ( locs ) {
		var tmp = [];

		// Walk over each tz string
		locs.forEach( function ( tz ) {
			var d = moment(),
				loc = null,
				offset = 0;

			// Set the moment's timezone to the timezone string
			d.tz( tz );
			// Get the numeric value of the UTC offset
			offset = d.utcOffset();

			// Try to get an existing element which has the same offset
			loc = self.arrayHas( locs, 'offset', offset );

			// If an existing element was not found, create a new one
			// and push it on to the collection
			if ( !loc ) {
				tmp.push( {
					olson: [tz],
					names: tz,
					offset: offset
				});
			}
			// Otherwise, stack the string to the existing object's olson
			// collection and string manipulate the name
			else {
				loc.olson.push(tz);
				loc.names += ', '+ tz;
			}
		});

		// Sort the collection of tz objects by their offset
		tmp.sort( self.sortByOffset );

		// Return the collection
		return tmp;
	};


	/**
	* Restores the object to it's default state
	*
	* @method reset
	* @return none
	*/
	self.reset = function () {
		self.selectedTZ( null );
		self.tzs.removeAll();
	};


	/**
	* Sorts a collection of objects by their offset property in ascending order
	*
	* @method sortByOffset
	* @return {Array}
	*/
	self.sortByOffset = function ( a, b ) {
		return ( a.offset < b.offset ) ? -1 : ( a.offset > b.offset ) ? 1 : 0;
	};


	/**
	* Self initialize
	*/
	if ( locs ) {
		self.parseLocations( locs );
	}

	/**
	* API
	*/
	return self;
};